// list-template-karrier.php tabs

$(() => {
	$(document).ready(() => {
		let url = location.href.replace(/\/$/, "");

		if (location.hash) {
			const hash = url.split("#");
			$('#yco-tabs a[href="#'+hash[1]+'"]').tab("show");
			url = location.href.replace(/\/#/, "/#");
			history.replaceState(null, null, url);
			setTimeout(() => {
				$(window).scrollTop(0);
			}, 400);
		}

		$('a[data-toggle="tab"]').on("click", function() {
			const hash = $(this).attr("href");
			let newUrl = url.split("#")[0] + hash;
			newUrl += "/";
			history.replaceState(null, null, newUrl);
		});
	});
});



// WEBPACK FOOTER //
// ./assets/scripts/karrier.js